import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLightbulb } from '@fortawesome/free-solid-svg-icons';
import styles from '../../styles/rca/rca.module.scss';

const RCAFormNotice = () => {

    return (
        <div className={`${styles.boxWrapper} ${styles.bgGreen} mb-5 text-start`} >
            <p className={`${styles.boxCategory}`}>
                <FontAwesomeIcon icon={faLightbulb} height={16} width={16} className="me-2 green"/>
                Completează corect formularul
            </p>
            <p className={styles.info}>
                Polița de asigurare va fi emisă în baza informațiilor completate. Daca datele nu sunt corecte, polița ar putea fi anulată sau ai putea suporta costuri suplimentare.</p>
        </div>
    )
}

export default RCAFormNotice;